<template>
  <div class="adult-check-view adult-password">
    <div class="adult-check-page">
      <div class="wrap">
        <header class="adult-check-header">
          <div class="header-top">
            <slot name="header"></slot>
          </div>
        </header>
        <div class="ch-adult-wrap">
          <span class="adult-tag"><Over19Icon/></span>
          <slot name="title"></slot>
          <div class="password" @click.prevent="clickWrapper">
            <!-- 비밀번호 입력 시 on 클래스 추가 필요 -->
            <div :class="getPwClass(0)">
              <label for="password1" class="a11y-hidden">비밀번호 1</label>
              <input type="number" pattern="[0-9]*" inputmode="numeric" id="password1" class="pw-inputs" name="password"
                     maxlength="1" required
                     @input.prevent="onKeyDown"
                     @keydown.delete="deletePinCode"
                     ref="pass0"
                     data-index="0">
              <span class="pw-img" v-if="password[0] !== ''"></span>
            </div>
            <div :class="getPwClass(1)">
              <label for="password2" class="a11y-hidden">비밀번호 2</label>
              <input type="number" pattern="[0-9]*" inputmode="numeric" id="password2" class="pw-inputs" name="password"
                     maxlength="1" required
                     @input.prevent="onKeyDown"
                     @keydown.delete="deletePinCode"
                     ref="pass1"
                     data-index="1">
              <span class="pw-img" v-if="password[1] !== ''"></span>
            </div>
            <div :class="getPwClass(2)">
              <label for="password3" class="a11y-hidden">비밀번호 3</label>
              <input type="number" pattern="[0-9]*" inputmode="numeric" id="password3" class="pw-inputs" name="password"
                     maxlength="1" required
                     @input.prevent="onKeyDown"
                     @keydown.delete="deletePinCode"
                     ref="pass2"
                     data-index="2">
              <span class="pw-img" v-if="password[2] !== ''"></span>
            </div>
            <div :class="getPwClass(3)">
              <label for="password4" class="a11y-hidden">비밀번호 4</label>
              <input type="number" pattern="[0-9]*" inputmode="numeric" id="password4" class="pw-inputs" name="password"
                     maxlength="1" required
                     @input.prevent="onKeyDown"
                     @keydown.delete="deletePinCode"
                     ref="pass3"
                     data-index="3">
              <span class="pw-img" v-if="password[3] !== ''"></span>
            </div>
          </div>
          <div class="link-area">
            <a href="#" @click.prevent="goResetPage">성인 비밀번호 초기화</a>
          </div>
          <slot name="bottom_buttons" v-bind:confirmFn="confirm.bind(this)"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Over19Icon from '@/assets/svg/common/img-age-19-ll.svg'
import utils from '@/common/util/utils'
import {
  CONFIRM_RESET_CHILDREN_PROTECTION_CODE_HTML
} from '@/common/message.const'
import { removeElement } from '@/common/util/modal.common'
export default {
  name: 'AdultPinCheck',
  components: {
    Over19Icon
  },
  props: {
    successFn: {
      type: Function
    }
  },
  data () {
    return {
      password: ['', '', '', ''],
      popup: null
    }
  },
  methods: {
    clickWrapper () {
      this.$refs.pass0.value = ''
      this.$refs.pass1.value = ''
      this.$refs.pass2.value = ''
      this.$refs.pass3.value = ''
      this.password = ['', '', '', ''].slice()
      this.$refs.pass0.focus()
    },
    onKeyDown (e) {
      const value = e.data
      if (Number.isNaN(Number(value))) {
        alert('숫자만 입력 가능 합니다.')
        this.clickWrapper()
      } else {
        const index = Number(e.target.dataset.index)
        const newPassword = this.password.slice()
        newPassword[index] = value
        this.password = newPassword
        this.$refs['pass' + index].value = ''
        const target = this.$refs['pass' + (index + 1)]
        if (target) {
          target.focus()
        } else {
          this.$refs['pass' + index].blur()
        }
      }
    },
    deletePinCode (e) {
      const index = Number(e.target.dataset.index)
      if (index === 0) return
      const newPassword = this.password.slice()
      newPassword[index - 1] = ''
      this.password = newPassword
      this.$refs['pass' + (index - 1)].focus()
    },
    async goResetPage () {
      if (await utils.asyncConfirm(CONFIRM_RESET_CHILDREN_PROTECTION_CODE_HTML)) {
        removeElement(document.querySelector('[data-modal="confirm"]'))

        // document.domain = DOCUMENT_DOMAIN
        const callback = encodeURIComponent(`${window.location.origin}/callback.html?action=setPinCode&result=`)
        const url = `https://member.wavve.com/mobile/auth/verifyage?type=pin&device=mobile&credential=${utils.cookies.getCredential()}&callback=${callback}`
        this.popup = window.open(url, '', '')
        this.popup.window.focus()
      }
    },
    confirm () {
      const actionFn = this.$route.params.action
      if (typeof actionFn === 'function') {
        actionFn({
          pincode: this.password.join(''),
          resetFn: this.clickWrapper.bind(this),
          successFn: typeof this.successFn === 'function' ? this.successFn.bind(this) : undefined })
      }
    },
    isOn (index) {
      return this.password[index] !== ''
    },
    getPwClass (index) {
      return this.password[index] === '' ? 'pw-each' : 'pw-each on'
    },
    postMessage (e) {
      if (e.origin === location.origin && e.data.eventMessage === 'setPinCode') {
        if (e.data.result === 'true') {
          this.$router.replace('/settings/adult/protect')
        }
        this.popup.close()
      }
    }
  },
  mounted () {
    window.addEventListener('message', this.postMessage)
  },
  watch: {
    password (newPassword, oldPassword) {
      this.password = newPassword
    }
  },
  beforeDestroy () {
    window.removeEventListener('message', this.postMessage)
  }
}
</script>
<style>

</style>
<style lang="css" src="@/assets/new-css/lnb.css"></style>
<style lang="css" src="@/assets/new-css/adult.css"></style>
